import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b97b369a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Dina produkter", -1))
const _hoisted_3 = { class: "summary-section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Dina uppgifter", -1))
const _hoisted_5 = { class: "summary-section" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Betalning", -1))
const _hoisted_7 = { class: "summary-section" }
const _hoisted_8 = { class: "button-and-price-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Totalbelopp inkl. angiven moms", -1))
const _hoisted_10 = { class: "price" }
const _hoisted_11 = {
  key: 0,
  class: "error-text"
}
const _hoisted_12 = { class: "booking-modal-content" }
const _hoisted_13 = { class: "icons" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }

import CustomTable from "@/components/generics/CustomTable.vue";
import SectionHeader from "@/components/generics/SectionHeader.vue";
import CustomerInputSummaryBlock from "@/components/blocks/CustomerInputSummaryBlock.vue";
import CustomerInputSwishBlock from "@/components/blocks/CustomerInputSwishBlock.vue";
import TermsAndConditionsCheckbox from "@/components/blocks/TermsAndConditionsCheckbox.vue";
import CustomButton from "@/components/generics/CustomButton.vue";
import SwishLogo from "@/assets/SVG/swishLogo.vue";
import ContentWrapper from "@/components/generics/ContentWrapper.vue";
import { order, useBookingStore } from "@/store/bookingStore";
import { useTrackingStore } from "@/store/trackingStore";
import CustomModal from "@/components/generics/CustomModal.vue";
import CustomLoader from "@/components/generics/CustomLoader.vue";
import tagluffaieuropa_logo from "@/assets/SVG/tagluffaieuropa_logo.vue";
import { onMounted, reactive } from "vue";
import { router } from "@/router/router";
import ticket from "@/types/ticket";


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryView',
  setup(__props) {

const bookingStore = useBookingStore();
const trackingStore = useTrackingStore();

const state = reactive({
  showModal: false,
  error: "",
});

onMounted(async () => {
  let urlParams = new URLSearchParams(window.location.search);
  const bookingId = urlParams.get("bookingId");
  console.log(bookingId);
  if (bookingId) {
    state.showModal = true;
    bookingStore.shoppingCart = [] as ticket[];
    bookingStore.order = {} as order;
    bookingStore.order.shoppingCartId = bookingId;
    var result = await bookingStore.other_half_of_checkout(
      bookingStore.shoppingCart,
      bookingStore.order
    );
    console.log(result);
    if (result == true) {
      router.push("/confirmation");
    } else {
      router.push("/");
    }
  }
});

var ticket_obj = bookingStore.shoppingCart.map((ticket) => ({
  Pass: ticket.title,
  Resenär: ticket.age,
  Komfort: ticket.comfort,
  Pris: ticket.price,
}));

function customer_info_valid() {
  if (!bookingStore.order.firstname) {
    return false;
  }
  if (!bookingStore.order.surname) {
    return false;
  }
  if (!bookingStore.order.adress) {
    return false;
  }
  if (!bookingStore.order.city) {
    return false;
  }
  if (!bookingStore.order.postalNumber) {
    return false;
  }
  if (!bookingStore.order.phoneNumber) {
    return false;
  }
  if (!bookingStore.order.email) {
    return false;
  }
  if (!bookingStore.order.swishFirstname) {
    return false;
  }
  if (!bookingStore.order.swishSurname) {
    return false;
  }
  if (!bookingStore.order.swishPhoneNumber) {
    return false;
  }
  if (!bookingStore.order.acceptTermsAndConditions) {
    return false;
  }
  if (!bookingStore.validateTicketsInCart(bookingStore.shoppingCart)) {
    return false;
  }
  return true;
}

async function handleBuyButtonClick() {
  state.showModal = true;
  trackingStore.trackEvent("initate_purchase");
  const res = await bookingStore.bookEurail(
    bookingStore.shoppingCart,
    bookingStore.order
  );

  if (res == true) {
    router.push("/confirmation");
  } else {
    console.log("Error handling");
    state.showModal = false;
    bookingStore.order.bookStatus = "";
    state.error = "Något har gått fel. Var god försök igen.";
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SectionHeader, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(CustomTable, { "table-items": _unref(ticket_obj) }, null, 8, ["table-items"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(SectionHeader, null, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(CustomerInputSummaryBlock)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SectionHeader, null, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(CustomerInputSwishBlock),
          _createVNode(TermsAndConditionsCheckbox)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(bookingStore).summarize_price()) + " kr", 1),
            (state.error != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(state.error), 1))
              : _createCommentVNode("", true),
            _createVNode(CustomButton, {
              class: "button",
              onClick: handleBuyButtonClick,
              disabled: !customer_info_valid()
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Köp biljetter ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(SwishLogo, { class: "swishlogo" })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(CustomModal, {
      show: state.showModal,
      "full-height": false,
      "un-removeable": true
    }, {
      header: _withCtx(() => [
        _createTextVNode(" Bokning utförs ")
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(SwishLogo)
          ]),
          (_unref(bookingStore).order.bookStatus == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Validerar din bokning. "))
            : _createCommentVNode("", true),
          (_unref(bookingStore).order.bookStatus == 'swish_pending')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Inväntar din swishbetalning. "))
            : _createCommentVNode("", true),
          (_unref(bookingStore).order.bookStatus == 'swish_paid')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Swish betald. Utför bokning. Var god stäng inte detta fönster. "))
            : _createCommentVNode("", true),
          _createVNode(CustomLoader)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})